import { css } from '@emotion/core';
import { variables, tokens } from '@domain-group/fe-brary';
var font = variables.font;
var colors = tokens.colors;
export var container = /*#__PURE__*/css("line-height:", font.baseLineHeight, ";display:flex;flex-direction:row;align-items:center;");
export var dropdowns = {
  name: "k008qs",
  styles: "display:flex;"
};
export var dropdown = {
  name: "huluao",
  styles: "margin:0 16px 0 0;"
};
export var dropdownPaddedContainer = {
  name: "1ruxp1v",
  styles: "padding:20px;"
};
export var moreOptionsPaddedContainer = {
  name: "g9qnka",
  styles: "padding:0 20px;"
};
export var propertyType = {
  name: "1qkhghx",
  styles: "width:430px;"
};
export var spacer = {
  name: "i9gxme",
  styles: "flex-grow:1;"
};
export var resetButton = /*#__PURE__*/css("border:0;margin-right:16px;padding:0;height:24px;outline:none;font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";background:none;white-space:nowrap;&:disabled{color:", colors.neutral.trim.default, ";}&:not(:disabled){cursor:pointer;color:", colors.neutral.base.default, ";&:hover{color:", colors.neutral.trim.default, ";}}");